"use strict";
/*
 * Created on 5. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Superclass for product prices.
 * @author Radek Beran
 */


var ProductPrice =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductPrice, _DomainObject_1$Domai);

  /**
   * @param value value of price
   * @param vatId internal id of VAT entity
   */
  function ProductPrice(value, vatId) {
    var _this;

    _classCallCheck(this, ProductPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPrice).call(this));
    _this.value = value;
    _this.vatId = vatId;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to CRP.
   */


  _createClass(ProductPrice, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ProductPrice(mat.value, mat.vatId);
    }
  }]);

  return ProductPrice;
}(DomainObject_1.DomainObject);

exports.ProductPrice = ProductPrice;

ProductPrice.productPriceSchema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductPrice.name);
  return {
    value: builder.opt(builder.bigNum('value')),
    vatId: builder.opt(builder.str('vatId'))
  };
}();